import React from 'react';

import { useParams } from 'react-router-dom';

//import UserViewRecords from '../../components/Shared/RecordsList/UserViewRecords'
import UserViewOneRecord from '../../../components/Shared/User/UserViewOneRecord'
import OpenReportButton from '../../../components/ConsultationProtocol/OpenReportButton'

import MainBlockHeader from '../../MainBlockHeader'
import MainBlockContainer from '../../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function RecordView() {  
  let { consultationUid, recordUid } = useParams();
  const { t } = useTranslation();

  return (
    <>              
      <MainBlockHeader header={t('recordList.header')} >
      </MainBlockHeader>

      <MainBlockContainer>      
        <UserViewOneRecord
          userUid={null}
          recordUid={recordUid}
          baseOneRecordUrl={ `/consultation/expert/accepted/${consultationUid}/user/record` }
          allowRequestConsultation={false}
          allowEditMarkers={true}
          getPageUserUrlTemplate={(userUid) => `/consultations/expert/accepted/${consultationUid}/user/records`}
        />
        <OpenReportButton locationType="accepted" />
      </MainBlockContainer>
    </>
  );  
}

